<template>
  <div class="detailSlider">
    <slick
      ref="slick"
      :options="slickOptions"
      @afterChange="handleAfterChange"
      @init="handleInit">
      <a :href="imageViewUrl(item)" target="_blank" class="img-container" v-for="(item, index) in data" :key="index">
        <div v-if="item.is360" class="img-overlay">
          <img src="/img/icons/ic_360@2x.png" alt="">
        </div>
        <img :src="item.thumbnail" alt="" :class="{detail : isDetail}" >
      </a>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import { backendUrl } from '@/lib/config'

export default {
  name: 'adx-slider',
  props: {
    data: {
      required: true
    },
    isCenter: {
      required: false
    },
    isCenterMobile: {
      required: false
    },
    slide: {
      required: false
    },
    arrow: {
      required: false,
      default: true
    },
    arrowMobile: {
      required: false,
      default: true
    },
    isImageShow: {
      required: false
    },
    isDetail: {
      required: false
    },
    imageIndex: {
      required: false,
      default: 0
    }
  },
  components: {
    'slick': Slick
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: this.slide,
        // nextArrow: this.isImageShow ? '<button type="button" style="' +
        //           'top:43%; position:absolute; right:0;background-image: linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0));border-radius: 0;border: none;width: 220px;height: 160px;box-shadow: none !important;background-color: unset;"' +
        //           'aria-disabled="false"><i style="font-size:40px;" class="icon-chevronright"></i></button>' :
        //           '<button type="button" style="' +
        //           'top:43%; width:32px; height:32px; position:absolute; right:10px;"' +
        //           'aria-disabled="false"><i class="icon-chevronright"></i></button>',
        nextArrow: '<button type="button" style="' +
                  'top:43%; width:32px; height:32px; position:absolute; right:10px;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
        // prevArrow: this.isImageShow ? '<button type="button" style="' +
        //           'top:43%; position:absolute; left:0; background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #ffffff);border-radius: 0;border: none;width: 220px;height: 160px;box-shadow: none !important;background-color: unset;"' +
        //           'aria-disabled="false"><i style="font-size: 40px" class="icon-chevronleft"></i></button>' :
        //           '<button type="button" style="' +
        //           'top:43%; position:absolute; left:10px;"' +
        //           'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
        prevArrow: '<button type="button" style="' +
                  'top:43%; position:absolute; left:10px;"' +
                  'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '50px',
              centerMode: this.isCenterMobile,
              arrows: this.arrowMobile,
              draggable: true
            }
          }
        ]
      },
    }
  },
  beforeUpdate() {
    if (this.$refs.slick) {
        this.$refs.slick.destroy();
    }
  },
  updated() {
    if (this.$refs.slick && !this.$refs.slick.$el.classList.contains('slick-initialized')) {
        this.$refs.slick.create();
    }
  },
  methods: {
    handleAfterChange(event, slick, currentSlide) {
      this.$emit('current', currentSlide)
    },
    handleInit(event, slick) {
      slick.goTo(this.imageIndex, true)
      this.$emit('init', slick.slideCount)
    },
    imageViewUrl(item) {
      if (item.is360) {
        return `${backendUrl}device/360viewer/${item.id}/`;
      }

      return item.viewer_url;
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.slick-slide {
  margin: 0 8px;
}
</style>
